import { db } from "@/services/firebase.service";
import { firestoreAction } from "vuexfire";

export default {
    createInvestor({ commit }, investor) {
        commit("ADD_INVESTOR", investor);
    },

    removeInvestor({ commit }, id) {
        commit("REMOVE_INVESTOR", id);
    },

    putInvestorsData({ commit }, investors) {
        commit("PUT_INVESTORS", investors);
    },

    SaveInvestors: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                investors_profiles: state.investors,
                current_step: rootGetters["user/getLastStep"](
                    "Profils des investisseurs"
                ),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Votre Entreprise"
                )
            });
    })
};
